<div class="profile-container">

  <!-- Header -->
  <div class="profile-header">
    <h1>Il mio profilo</h1>
    <p class="subtitle">Gestisci le tue informazioni personali</p>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Form -->
  <mat-card class="profile-card" *ngIf="!isLoading">

    <mat-card-content>
      <form [formGroup]="profileForm" class="profile-form">

        <div class="form-row">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="Name" placeholder="Inserisci il nome">
            <mat-icon matPrefix>person</mat-icon>
            <mat-error *ngIf="hasError('Name', 'required')">
              Il nome è obbligatorio
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Cognome</mat-label>
            <input matInput formControlName="Surname" placeholder="Inserisci il cognome">
            <mat-icon matPrefix>person</mat-icon>
            <mat-error *ngIf="hasError('Surname', 'required')">
              Il cognome è obbligatorio
            </mat-error>
          </mat-form-field>
        </div>

      </form>
    </mat-card-content>

    <mat-card-actions class="form-actions">
      <button
        mat-raised-button
        type="button"
        [color]="saveButton.matherialOptions?.color"
        (click)="saveButton.action()"
        [disabled]="profileForm.invalid || isSaving">
        <span *ngIf="!isSaving">{{ saveButton.label }}</span>
        <span *ngIf="isSaving" style="display: flex; align-items: center; gap: 8px;">
          <mat-spinner diameter="20"></mat-spinner>
          Salvataggio...
        </span>
      </button>
    </mat-card-actions>

  </mat-card>

  <!-- Componente riutilizzabile per cambio password -->
  <app-change-password-card
    *ngIf="!isLoading"
    title="Account"
    description="Modifica la tua password"
    buttonLabel="Modifica Password">
  </app-change-password-card>

  <!-- Moduli associati all'utente (ultimo box) - solo se ne ha almeno uno -->
  <mat-card class="profile-card modules-card" *ngIf="!isLoading && hasModules && modulesDatatable">
    <mat-card-content>
      <h2 class="modules-title">I miei moduli</h2>
      <ct-datatable [configuration]="modulesDatatable" (reload)="onModulesReload()"></ct-datatable>
    </mat-card-content>
  </mat-card>

  <!-- Cella "Visionato": pallino verde (visionato) / rosso (non visionato) -->
  <ng-template #viewedCell let-row="row">
    <span
      class="status-dot"
      [class.viewed]="row?.viewed"
      [class.not-viewed]="!row?.viewed"
      [title]="row?.viewed ? 'Visionato' : 'Non visionato'"></span>
  </ng-template>

</div>
